


export function getHeadPic(ip,headPic){
    if(headPic == undefined){
        return '';
    }
    if(headPic.includes("http")){
        //微信头像
        return headPic;
    }else{
        return ip + headPic;
    }
}



// WEBPACK FOOTER //
// ./src/utils/spreaderUtils.js